import Component from '../core/Component'

export const STATES = {
    OPEN: 'is-open'
}

export default class DropdownSelect extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            placeholder: null,
            labels: [],
            close: null
        }

        this.placeholderText = ''
        this.defaultPlaceholderText = this.ref.placeholder.innerText

        this.timerPreventOpen = null
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.element.addEventListener('click', this.handleClick)
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseOut)
        this.element.addEventListener('focusin', this.handleFocusIn)
        this.element.addEventListener('focusout', this.handleFocusOut)

        this.ref.close?.addEventListener('click', this.handleCloseClick)
    }

    handleFocusIn = () => {
        this.open()
    }

    handleMouseEnter = () => {
        this.open()
    }

    handleMouseOut = () => {
        this.close()
    }

    handleClick = event => {
        this.open()
    }

    handleCloseClick = () => {
        this.close()
    }

    handleChange = event => {
        this.updatePlaceholder()
        this.close()
    }

    open() {
        if (this.timerPreventOpen) {
            return
        }

        this.element.classList.add(STATES.OPEN)
    }

    close() {
        clearTimeout(this.timer)

        this.element.classList.remove(STATES.OPEN)

        this.timerPreventOpen = setTimeout(() => {
            this.timerPreventOpen = null
        }, 300)
    }

    updatePlaceholder() {

        const placeholderText = this.ref.labels.filter(label => label.querySelector('input').checked).map(label => label.textContent.trim()).join(', ') //IE11 neumi label.control

        if (placeholderText === this.placeholderText) {
            return
        }

        this.placeholderText = placeholderText || this.defaultPlaceholderText

        this.ref.placeholder.innerText = this.placeholderText
        this.ref.placeholder.setAttribute('title', this.placeholderText)
    }
}